import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedDate, FormattedTime } from 'react-intl'

export const columnsCampaign = {
  type: 'Campaign',
  fields: [
    {
      name: 'name',
      description: 'Campaign Name',
      column_label: 'Campaign Name',
      column_label_skip_except_root: true,
      Cell: row => {
        return row.original ? row.original.name : undefined
      }
    },
    {
      name: 'code',
      description: 'Code'
    },
    {
      name: 'description',
      description: 'Description'
    },
    {
      name: 'lead_source',
      description: 'Lead Source',
      type: 'LeadSource'
    },
    {
      name: 'marketing_campaign',
      description: 'Sales Campaign',
      type: 'SalesCampaign'
    },
    {
      name: 'transaction_type_code',
      description: 'Transaction Type'
    },
    {
      name: 'auto_launch_sales_process',
      description: 'Auto Launch Sales'
    }
  ]
}

export const columnsSalesCampaign = {
  type: 'SalesCampaign',
  fields: [
    {
      name: 'name',
      description: 'Name',
      Cell: row => {
        return row.original ? row.original.name : undefined
      }
    },
    {
      name: 'code',
      description: 'Code'
    },
    {
      name: 'description',
      description: 'Description'
    },
    {
      name: 'lead_source',
      description: 'Lead Source',
      type: 'LeadSource'
    },
    {
      name: 'transaction_type_code',
      description: 'Transaction Type'
    },
    {
      name: 'auto_launch_sales_process',
      description: 'Auto Launch Sales'
    }
  ]
}

export const columnsLeadSource = {
  type: 'LeadSource',
  fields: [
    {
      name: 'name',
      description: 'Name'
    },
    {
      name: 'code',
      description: 'Code'
    },
    {
      name: 'kind',
      description: 'Kind'
    },
    {
      name: 'description',
      description: 'Description'
    }
  ]
}
